import '@assets/main.css';
import { VueQueryPlugin } from '@tanstack/vue-query';
import {
  CellStyleModule,
  ClientSideRowModelApiModule,
  ClientSideRowModelModule,
  ExternalFilterModule,
  ModuleRegistry as AgGridModuleRegistry,
  RowSelectionModule,
  RowStyleModule,
  TextEditorModule,
  TooltipModule,
} from 'ag-grid-community';
import FloatingVue from 'floating-vue';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import App from '@/App.vue';
import { vPTooltip } from '@/components/p-tooltip/pTooltipDirective';
import { setupVueTrace } from '@/plugins/devTools';
import { setupLayoutComponents } from '@/plugins/layout';
import { ModalPlugin } from '@/plugins/modal';
import { setupSentry } from '@/plugins/sentry';
import { ToastPlugin } from '@/plugins/toast';
import { router } from '@/router';

// Set the default distance for all tooltips
FloatingVue.options.themes.tooltip.distance = 12;
AgGridModuleRegistry.registerModules([
  ClientSideRowModelModule,
  ClientSideRowModelApiModule,
  RowSelectionModule,
  RowStyleModule,
  TooltipModule,
  CellStyleModule,
  TextEditorModule,
  ExternalFilterModule,
]);

const pinia = createPinia();

const app = createApp(App);

setupLayoutComponents(app);

setupSentry(app, router);

setupVueTrace();

app.use(pinia);

app.use(router);

app.use(VueQueryPlugin, {
  enableDevtoolsV6Plugin: true,
  queryClientConfig: {
    defaultOptions: {
      queries: {
        retry: false,
      },
    },
  },
});

app.use(FloatingVue);

app.use(ToastPlugin(router));

app.use(ModalPlugin);

app.directive('p-tooltip', vPTooltip);

app.mount('#app');
